// extracted by mini-css-extract-plugin
module.exports = {"form":"Checkout_form__3i3hF","control":"Checkout_control__2PvKi","actions":"Checkout_actions__33d6I","submit":"Checkout_submit__2koK9","invalid":"Checkout_invalid__NIWfF"};